import * as React from 'react';
import ReactDOM from 'react-dom';
import './AuthenticationReturnMode.css';

const AuthenticationReturnMode = () => {
  // Render a loading spinner svg, with markup and content boldly copied from
  // sail.
  return (
    <div
      id="loading-spinner"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <svg
        viewBox="0 0 24 24"
        role="status"
        aria-label="Loading"
        style={{
          color: '#87909f',
          height: 24,
          animation:
            '250ms ease 0s 1 normal none running SpinnerAnimationShow, 0.7s linear 0s infinite normal none running SpinnerAnimationRotation',
          transitionProperty: 'opacity, transform',
          transitionTimingFunction: 'ease',
          transformOrigin: '50% 50%',
        }}
      >
        <g transform="translate(1 1)" fillRule="nonzero" fill="none">
          <circle cx="11" cy="11" r="11" />
          <path
            d="M10.998 22a.846.846 0 0 1 0-1.692 9.308 9.308 0 0 0 0-18.616 9.286 9.286 0 0 0-7.205 3.416.846.846 0 1 1-1.31-1.072A10.978 10.978 0 0 1 10.998 0c6.075 0 11 4.925 11 11s-4.925 11-11 11z"
            fill="currentColor"
          />
        </g>
      </svg>
    </div>
  );
};

export const initializeAuthenticationReturnMode = () => {
  const [container] = document.getElementsByClassName(
    'financial-partner-app-container',
  );

  ReactDOM.render(<AuthenticationReturnMode />, container);
};
